export class BaseService {
    protected serialize(obj: any, completed: string[] = [], path: string = "filter", nest?: string): string {
        let i=0;
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const newpath = !isNaN(+key) ? path + "[" + i + "]" : path + "." + key;
                if (typeof obj[key] === 'object') {
                    this.serialize(obj[key], completed, newpath);
                } else {
                    completed.push(newpath.concat("=" + encodeURIComponent(obj[key])));
                }
                i++;
            }
        }

        return completed.join("&");
    }
}